// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CollapsibleList-cls1__cac662479cb35da17acd{/*!*/}.CollapsibleList-cls2__fb2bcd9e235e12f1bcdb{background:transparent;border:0;color:#1e2a40;font-size:14px;line-height:1.3;padding:2px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CollapsibleList-cls1__cac662479cb35da17acd",
	"cls2": "CollapsibleList-cls2__fb2bcd9e235e12f1bcdb CollapsibleList-cls1__cac662479cb35da17acd"
};
export default ___CSS_LOADER_EXPORT___;
